// src/components/AppTopBar.jsx
import React from "react";
import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

export default function AppTopBar({
  title = "Deposit",
  showBack = false,
  onBack,
  rightSlot = null,
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const isLight = theme.palette.mode === "light";

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: theme.palette.background.default,
        color: theme.palette.text.primary,
        borderBottom: `1px solid ${theme.palette.text.secondary}22`,
      }}
    >
      <Toolbar sx={{ minHeight: 64, gap: 1 }}>
        {showBack && (
          <IconButton
            edge="start"
            onClick={onBack || (() => navigate(-1))}
            aria-label="back"
            sx={{ color: theme.palette.text.primary }}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>
        )}
        <Typography
          variant="h6"
          sx={{ fontWeight: 800, letterSpacing: 0.2, flexGrow: 1 }}
        >
          {title}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {rightSlot}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
